// 데이터셋 파일 객체값 format
export const flattenTransformedData = (transformedData) => {
  let flattenedData = [];

  Object.keys(transformedData).forEach((label) => {
    transformedData[label].forEach((item) => {
      flattenedData.push({ ...item, label });
    });
  });

  return flattenedData;
};

// 파일 format
export const extractFileData = (files) => {
  return Object.keys(files).reduce((acc, key) => {
    acc[key] = files[key];
    return acc;
  }, {});
};

// current경로 + 선택된 파일
export const combinePathAndNames = (currentPath, newSelectedFileIds) => {
  const combinedArray = [];

  newSelectedFileIds.forEach((fileObj) => {
    combinedArray.push({
      path: `${currentPath}/${fileObj.name}`,
      id: fileObj.id,
    });
  });
  return combinedArray;
};

// 선택된 라벨값 붙이기 (selectedFiles)
export const addLabelToCombinedArray = (combinedArray, selectedLabel) => {
  return combinedArray.map((fileObj) => ({
    ...fileObj,
    label: selectedLabel,
  }));
};

// 라벨링된 파일 선택 -> 배열로 변환
export const extractLabeldFilesArray = (fileList) => {
  const resultArray = [];

  fileList.forEach((entry) => {
    resultArray.push(entry);
  });

  return resultArray;
};

// 폴더로 선택된 전체 파일에 라벨링
export function createLabeledArray(arrayData, selectedLabel) {
  return arrayData.map((path) => ({
    path: path,
    label: selectedLabel,
  }));
}

// label: ["files"] 형태로 변환
export function transFiles(data) {
  const result = {};

  data.forEach((item) => {
    if (!result[item.label]) {
      result[item.label] = [];
    }
    result[item.label].push(item.path);
  });

  return result;
}

// 베이스 경로 자르기
export function removePathPrefix(path) {
  const prefix = "/data1/datasets";

  if (path === prefix) {
    return "/";
  } else if (path.startsWith(prefix)) {
    return path.slice(prefix.length);
  }
  return path;
}

export function getLastPathSegment(path) {
  const parts = path.split("/");
  return parts.slice(-2).join("/");
}

export function transformData(data) {
  let transformedData = {
    unlabeled: [],
  };

  if (Array.isArray(data.all)) {
    data.all.forEach((item) => {
      const id = item[0];
      const path = item[1];
      const label = item[2];

      if (!transformedData[label]) {
        transformedData[label] = [];
      }

      transformedData[label].push({ id, path });
    });
  }

  if (Array.isArray(data.valid)) {
    data.valid.forEach((item) => {
      const id = item[0];
      const path = item[1];
      const label = item[2];

      if (!transformedData[label]) {
        transformedData[label] = [];
      }

      transformedData[label].push({ id, path });
    });
  }

  if (Array.isArray(data.unlabeled)) {
    data.unlabeled.forEach((item) => {
      const id = item[0];
      const path = item[1];
      transformedData["unlabeled"].push({ id, path });
    });
  }

  return transformedData;
}

// 이미지 경로만 추출하는 함수
export function extractImgPaths(data) {
  const transformedData = {
    unlabeled: [],
  };

  const processItems = (items) => {
    items.forEach((item) => {
      const path = item[1];
      const label = item[2] || "unlabeled"; // unlabeled에는 label이 없으므로 기본값
      if (!transformedData[label]) {
        transformedData[label] = [];
      }
      transformedData[label].push(path);
    });
  };

  if (Array.isArray(data.all)) {
    processItems(data.all);
  }

  if (Array.isArray(data.valid)) {
    processItems(data.valid);
  }

  if (Array.isArray(data.unlabeled)) {
    data.unlabeled.forEach((item) => {
      const path = item[1];
      transformedData.unlabeled.push(path);
    });
  }

  return transformedData;
}

export function randomizeLabels(data, randomLabels = [], targetLabel) {
  console.log(targetLabel, data);
  const transformedData = {
    ["etc"]: [],
  };

  // 랜덤 라벨 하나 가져오는 함수
  const getRandomLabel = () => {
    if (randomLabels.length === 0) return "unlabeled";
    const index = Math.floor(Math.random() * randomLabels.length);
    return randomLabels[index];
  };

  const processItems = (items) => {
    console.log(items);
    items.forEach((item) => {
      const path = item[1];
      const lbl = item[2];

      // targetLabel과 일치하는 것만 처리
      if (lbl !== targetLabel) return;

      const randomLabel = getRandomLabel();

      if (!transformedData[randomLabel]) {
        transformedData[randomLabel] = [];
      }

      transformedData[randomLabel].push(path);
    });
  };

  if (Array.isArray(data.all)) {
    processItems(data.all);
    console.log(transformedData);
  }

  if (Array.isArray(data.valid)) {
    processItems(data.valid);
  }

  // if (Array.isArray(data.unlabeled)) {
  //   processItems(data.unlabeled);
  // }

  return transformedData;
}

export function transformDatasetFiles(data) {
  let transformedData = {
    train: [],
    unlabeled: [],
    valid: [],
  };

  const usedTrainPaths = new Set();

  const pushTrain = (item) => {
    const [id, path, label] = item;

    if (usedTrainPaths.has(path)) return;

    usedTrainPaths.add(path);

    transformedData.train.push({
      id,
      path,
      label,
      score: 0,
      status: "none",
    });
  };

  if (Array.isArray(data.all)) {
    data.all.forEach(pushTrain);
  }

  if (Array.isArray(data.train)) {
    data.train.forEach(pushTrain);
  }

  if (Array.isArray(data.valid)) {
    data.valid.forEach((item) => {
      const id = item[0];
      const path = item[1];
      const label = item[2];
      const score = 0;
      const status = "none";

      transformedData["valid"].push({ id, path, label, score, status });
    });
  }

  if (Array.isArray(data.unlabeled)) {
    data.unlabeled.forEach((item) => {
      const id = item[0];
      const path = item[1];
      const status = "none";

      transformedData["unlabeled"].push({ id, path, status });
    });
  }

  return transformedData;
}

// export const flattenTransformDatasetFiles = (transformedData) => {
//     let flattenedData = {
//     train:[],
//     unlabeled: [],
//     valid:[]
//   };

//   Object.keys(transformedData).forEach((label) => {
//     transformedData[all].forEach((item) => {
//       flattenedData.push({ ...item, label });
//        flattenedData["train"].push({ id, path, label });
//     });
//   });

//   return flattenedData;
// };

// 풀데이터를 데이터셋 업데이트 형식에 맞춰 반환
export const convertEditDataSet = (ngReviews) => {
  return ngReviews.map((item) => ({
    id: item.id,
    path: item.path,
    label: getReviewClass(item.review),
  }));
};

// review: {"label_cls":["dent"]} 또는 {"label_seg":[...], "label_cls":["NG"]}, 미리뷰는 빈 값 그대로
const getReviewClass = (review) => (review ? JSON.parse(review).label_cls?.[0] : review);

// 데이터셋 클래스리스트에 따른 라벨링/카운트
export const calculateLengths = (data) => {
  let counts = {
    unlabeled:
      data.unlabeled && Array.isArray(data.unlabeled)
        ? data.unlabeled.length
        : 0,
  };

  if (Array.isArray(data.class_list)) {
    data.class_list.forEach((className) => {
      if (className !== "unlabeled") {
        counts[className] = 0;
      }
    });
  }

  if (Array.isArray(data.all)) {
    data.all.forEach((item) => {
      const label = item[2]; // 라벨이 항상 마지막 두 번째 항목에 있다고 가정
      if (counts.hasOwnProperty(label)) {
        counts[label]++;
      }
    });
  }

  if (Array.isArray(data.valid)) {
    data.valid.forEach((item) => {
      const label = item[2]; // 라벨이 항상 마지막 두 번째 항목에 있다고 가정
      if (counts.hasOwnProperty(label)) {
        counts[label]++;
      }
    });
  }

  return Object.keys(counts).map((label) => ({ label, count: counts[label] }));
};
